const R = require('ramda')
module.exports = function(value) {
  return R.or(value,'');
};
